import { Fragment, useState } from "react";
import { Button } from "react-bootstrap";
import { Trash, EyeFill, Link45deg, Paperclip } from "react-bootstrap-icons";

const TableRow = (props) => {
    const { row, onclick, cols, indx, buttons, style } = props;
    const [dispalyDetail, setDisplay] = useState(false);
    let mobileCols = cols.filter(c => c.showInMobile && c.colName.toLowerCase() !== "rownumber");
    let webCols = cols.filter(c => !c.showInMobile && c.colName.toLowerCase() !== "rownumber");
    const rowNumber = cols.find(c => c.colName.toLowerCase() === "rownumber");
    const rowClick = (item) => {
        if (window.innerWidth <= 414) {
            setDisplay(!dispalyDetail);
        }
        else {
            if (onclick) {
                onclick(item);
            }
        }
    }
    return (

        <Fragment key={indx}>
            <tr className="resultTableRow" onClick={() => rowClick(row)} style={style}>
                {rowNumber && <td style={{ width: "40px" }}>{indx + 1}</td>}
                {mobileCols.map((item, i) =>
                    <td key={i} style={item.style ? item.style : {}} className={item.hasTooltip ? "tooltipCol" : ""}>
                        {item.colType === "currency" && (!row[item.colName] ? 0 : row[item.colName].toLocaleString(navigator.language, { minimumFractionDigits: 0 }))}
                        {item.colType === "boolean" && <input type="checkbox" checked={row[item.colName]} readOnly />}
                        {item.colType === "number" && row[item.colName]}
                        {item.colType === "string" && row[item.colName] && (row[item.colName]?.substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : ""))}
                        {!item.colType && row[item.colName]}
                        {item.hasTooltip && row[item.colName] && item.maxTextLength < row[item.colName].length && <span className="tooltipSpan">{row[item.colName]}</span>}
                    </td>)}
                {
                    window.innerWidth > 414 &&
                    <Fragment>
                        {webCols &&
                            webCols.map((item, i) =>
                                <td key={i} style={item.style ? item.style : {}} className={item.hasTooltip ? "tooltipCol" : ""}>
                                    {item.colType === "currency" && (!row[item.colName] ? 0 : row[item.colName].toLocaleString(navigator.language, { minimumFractionDigits: 0 }))}
                                    {item.colType === "boolean" && <input type="checkbox" checked={row[item.colName]} readOnly />}
                                    {item.colType === "number" && row[item.colName]}
                                    {item.colType === "string" && row[item.colName] && (row[item.colName]?.substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : ""))}
                                    {!item.colType && row[item.colName]}
                                    {item.hasTooltip && row[item.colName] && item.maxTextLength < row[item.colName].length && <span className="tooltipSpan">{row[item.colName]}</span>}
                                </td>)
                        }
                        {
                            buttons &&
                            <td>
                                {buttons.map((b, i) => {
                                    return (
                                        (b.showCondition === undefined || b.showCondition(row) === true) &&
                                        <Fragment key={i}>

                                            {b.type === "delete" &&
                                                <Trash title="حذف" className="rowBtn" color="red" size={b.size ?? 18} onClick={() => { b.onclick(row) }} />
                                            }
                                            {b.type === "show" &&
                                                <EyeFill className="rowBtn" style={{ marginRight: "3px" }} color="#0e68df" size={b.size ?? 18} onClick={() => { b.onclick(row) }} />
                                            }
                                            {b.type === "attach" &&
                                                <Paperclip className="rowBtn" style={{ marginRight: "3px" }} color="blue" size={b.size ?? 18} onClick={() => { b.onclick(row) }} />
                                            }
                                            {b.type === "related" &&
                                                <Link45deg className="rowBtn" style={{ marginRight: "3px" }} color="blue" size={b.size ?? 18} onClick={() => { b.onclick(row) }} />
                                            }
                                            {b.type === "common" &&
                                                <button className="btn" style={{ padding: 0 }} onClick={() => { b.onclick(row) }}>{b.icon}</button>
                                            }
                                            {!b.type &&
                                                <Button style={{ marginRight: "3px" }} onClick={() => { b.onclick(row) }} className={b.className}>{b.title}</Button>
                                            }


                                        </ Fragment>)
                                })}
                            </td>
                        }
                    </Fragment>
                }
            </tr>
            {
                window.innerWidth <= 414 &&
                <tr style={{ display: dispalyDetail ? "table-row" : "none" }}>
                    <td colSpan={mobileCols?.length} style={{ border: "1px solid #a7aab6", borderRadius: "2px" }}>
                        <div className='row'>
                            {webCols.map((item, i) => {
                                return (
                                    <Fragment key={i}>
                                        <div className="col-6 mt-2"> {item.colTitle}</div>
                                        <div className="col-6  mt-2">
                                            {item.colType === "currency" && row[item.colName]?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                            {item.colType === "boolean" && <input type="checkbox" readOnly checked={row[item.colName] ?? false} />}
                                            {item.colType === "number" && row[item.colName]}
                                            {!item.colType && row[item.colName]}
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </div>
                        <div className="row" style={{ padding: "5px", paddingRight: "10px" }}>
                            <div className="col-md-4" >
                                {buttons && buttons.map((b, i) => {
                                    return ((b.showCondition === undefined || b.showCondition(row) === true) && <Button key={"btn" + i} onClick={() => { b.onclick(row) }} className={b.className}>{b.title}</Button>)
                                }
                                )}
                            </div>
                        </div>
                    </td>
                </tr>

            }
        </Fragment>
    );
}
export default TableRow;